
import React from 'react';
import { Textarea } from '@/components/ui/textarea';

interface BookingFormMessageProps {
  message: string;
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const BookingFormMessage: React.FC<BookingFormMessageProps> = ({ 
  message, 
  handleChange 
}) => {
  return (
    <div>
      <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
        Tell us about your IT needs
      </label>
      <Textarea
        id="message"
        name="message"
        value={message}
        onChange={handleChange}
        placeholder="Briefly describe your current IT challenges or goals..."
        rows={5}
        className="w-full"
      />
    </div>
  );
};

export default BookingFormMessage;
